import { enrichTemplateKpis } from "./enrichTemplateKpis";

/**
 * Mirrors the in-service grouping that was previously done on the backend.
 * Groups the company's selected KPIs by module, sorted by module name then KPI
 * title. Returns an array of `[moduleName, items]` tuples.
 * (Consumed by the Triggers Excel template; the Quantative template uses
 * buildSortedGroups, which additionally clusters by category.)
 */
export const buildSortedModules = (input) => {
  const enriched = enrichTemplateKpis(input);

  const groupedByModule = new Map();
  for (const { group, item } of enriched) {
    const moduleName = group.module || "Other";
    if (!groupedByModule.has(moduleName)) groupedByModule.set(moduleName, []);
    groupedByModule.get(moduleName).push(item);
  }

  return Array.from(groupedByModule.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([moduleName, items]) => [
      moduleName,
      [...items].sort((x, y) => (x.title || "").localeCompare(y.title || "")),
    ]);
};
